import {texture} from "p3";
import definitions from "../definitions";
import GameScene from "../scenes/GameScene";

export default class ActionButton extends P3.Button {
    constructor() {
        super(new P3.ButtonStates(texture("btn_action_large_out"), null, null, PIXI.Texture.EMPTY));

        this._action = null;
        this._tween = null;

        this.animate = true;
        this.animateIcon = true;

        this.setAction(definitions.PLAYER_ACTION.ATTACK, false);
    }

    destroy() {
        this.stopAnimation();

        super.destroy();
    }

    /**
     * @return {Promise}
     */
    animateActionIcon() {
        return new Promise((resolve) => {
            this.stopAnimation();

            this._icon.scale.set(0);
            this._tween = gsap.to(this._icon.scale, 0.2, {
                x: 1,
                y: 1,
                ease: "back.out(2)",
                onComplete: resolve
            })
            GameScene.active.addTween(this._tween);
        });
    }

    stopAnimation() {
        if (this._tween) {
            GameScene.active.removeTween(this._tween, true);
            this._tween = null;
        }
    }

    promptButton() {
        if (this._tween.isActive()) {
            return;
        }

        this._tween = gsap.to(this.animation.scale, 0.2, {
            x: this.animateDownScale.x,
            y: this.animateDownScale.y,
            ease: Power1.easeInOut,
            yoyo: true,
            repeat: 1
        })
        GameScene.active.addTween(this._tween);
    }

    /**
     * @param {number} value
     * @param {boolean} [animate=false]
     */
    setAction(value, animate = false) {
        if (this._action !== value) {
            this._action = value;

            let tex;
            switch (this._action) {
                default:
                case definitions.PLAYER_ACTION.ATTACK: { 
                    tex = texture("btn_icon_large_sword");
                    break;
                }
                case definitions.PLAYER_ACTION.INTERACT: {
                    tex = texture("btn_icon_interact");
                    break;
                }
                case definitions.PLAYER_ACTION.TALK: {
                    tex = texture("btn_icon_large_speech_bubble");
                    break;
                }
            }

            const states = this._states;
            states.icon = tex;
            this.setStates(states);

            this.animateActionIcon().then();
        }
    }

    /**
     * @return {string}
     */
    get action() {
        return this._action;
    }
}